export enum FloatActionButtonEnum {
    Voltar = 1,
    Editar = 2,
    Salvar = 3,
    Formularios = 4,
    Remover = 5,
    Incluir = 6,
    Clonar = 7,
}
